const mediaItems = [
  {
    title: "独家：某顶流男星酒店密会视频全解析",
    duration: "12:38",
    views: "28.6万",
    img: "https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20at%20night%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20red%20exit%20sign%20glow%2C%20film%20noir%20style%2C%20investigative%20photography%2C%20moody%20lighting%20with%20deep%20contrast&width=800&height=450&seq=media-01&orientation=landscape",
  },
  {
    title: "实拍：带货主播后台真实发货现场",
    duration: "08:15",
    views: "19.3万",
    img: "https://readdy.ai/api/search-image?query=Busy%20warehouse%20packing%20station%20with%20boxes%2C%20dark%20industrial%20setting%2C%20dramatic%20overhead%20lighting%2C%20amber%20warm%20glow%2C%20documentary%20photography%20style%2C%20moody%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape",
  },
  {
    title: "录音曝光：某选秀导演谈内定选手",
    duration: "15:42",
    views: "35.1万",
    img: "https://readdy.ai/api/search-image?query=Audio%20recording%20device%20on%20dark%20table%2C%20dramatic%20spotlight%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20warm%20red%20accent%20lighting%2C%20film%20noir%20style&width=800&height=450&seq=media-03&orientation=landscape",
  },
  {
    title: "深扒：网红情侣分手背后的资本博弈",
    duration: "10:56",
    views: "22.7万",
    img: "https://readdy.ai/api/search-image?query=Two%20chairs%20facing%20away%20from%20each%20other%20in%20dark%20room%2C%20dramatic%20split%20lighting%2C%20emotional%20distance%20metaphor%2C%20cinematic%20composition%2C%20moody%20atmosphere%20with%20amber%20highlights&width=800&height=450&seq=media-04&orientation=landscape",
  },
  {
    title: "复盘：品牌代言翻车事件全时间线",
    duration: "18:20",
    views: "41.2万",
    img: "https://readdy.ai/api/search-image?query=Collapsed%20billboard%20in%20dark%20urban%20setting%2C%20dramatic%20night%20scene%2C%20broken%20advertisement%20metaphor%2C%20amber%20street%20light%2C%20cinematic%20photography%2C%20moody%20atmosphere%20with%20deep%20shadows&width=800&height=450&seq=media-05&orientation=landscape",
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          视频猛料
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-4 rounded-full"></div>
        <p className="text-center text-foreground-500 text-xs mb-10">独家视频报道与深度解析</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-colors group cursor-pointer ${
                i === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`relative ${i === 0 ? "aspect-[16/7]" : "aspect-[16/10]"}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 bg-black/70 text-foreground-200 text-xs px-2 py-1 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-foreground-200 text-sm mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-foreground-500 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}